export const experience = [
  {
    company: "Digital Republic",
    context: "allocated to AZZAS 2154",
    role: "Full Stack Developer",
    period: "Feb 2025 - Present",
    activities: [
      "Develop features with React.js and Next.js, keeping style and the design system consistent with Figma using Tailwind CSS",
      "Model data with PostgreSQL and Prisma ORM and build backend features with Nest.js",
      "Deploy and maintain services on Google Cloud Platform using Docker with Cloud Run",
      "Build CI/CD pipelines with GitHub Actions for tests, preview deploys and code validation",
      "Write tests with Vitest and Playwright, and configure Sentry for error monitoring",
    ],
    skills: [
      "Next.js",
      "React.js",
      "Nest.js",
      "Prisma ORM",
      "PostgreSQL",
      "MySQL",
      "GCP",
      "Docker",
      "GitHub Actions",
      "Vitest",
      "Playwright",
      "Sentry",
    ],
  },
  {
    company: "Viptech Smart Solutions",
    role: "Full Stack Developer",
    period: "Sep 2024 - Jan 2025",
    activities: [
      "Implemented features in React and Next.js applications",
      "Developed and maintained Nest.js microservices",
      "Maintained infrastructure with Terraform, Kubernetes, Docker and AWS",
      "Used Redis for caching and ran SQL queries against PostgreSQL",
    ],
    skills: [
      "React",
      "Next.js",
      "Nest.js",
      "TypeScript",
      "PostgreSQL",
      "AWS",
      "Terraform",
      "Kubernetes",
      "Redis",
    ],
  },
  {
    company: "Muu Agrotech",
    role: "Backend Developer",
    period: "Sep 2023 - May 2024",
    activities: [
      "Built and maintained scalable RESTful microservices in Node.js (TypeScript) with Nest.js and Express",
      "Managed data persistence with PostgreSQL and MongoDB",
      "Integrated Keycloak for role-based access control (RBAC)",
      "Used Elasticsearch for optimized search and caching",
    ],
    skills: [
      "Node.js",
      "TypeScript",
      "Nest.js",
      "Express",
      "PostgreSQL",
      "MongoDB",
      "Keycloak",
      "Elasticsearch",
      "Docker",
    ],
  },
  {
    company: "Muu Agrotech",
    role: "Full Stack Developer",
    period: "Jun 2023 - Sep 2023",
    activities: [
      "Built responsive UIs with React.js and TypeScript following Figma designs",
      "Styled components with Material UI and integrated external APIs (Conta Azul, Iugu)",
      "Maintained RESTful APIs with Node.js, Nest.js and Express.js",
      "Configured Sentry across services, frontend and mobile applications",
    ],
    skills: ["React", "TypeScript", "Material UI", "Express", "Sentry", "Redux"],
  },
  {
    company: "TechX Digital Solutions",
    role: "Full Stack Software Engineer",
    period: "May 2023 - Oct 2023",
    activities: [
      "Developed features with React.js, TypeScript and Next.js (SSR)",
      "Integrated Supabase as a Backend as a Service (BaaS)",
      "Built responsive UIs with Chakra UI and CSS",
    ],
    skills: ["React", "TypeScript", "Next.js", "Supabase", "CSS"],
  },
  {
    company: "Trybe",
    role: "Auxiliary Instructor",
    period: "Sep 2022 - Apr 2023",
    activities: [
      "Debugged code and facilitated pair programming in Node.js, TypeScript and Express projects",
      "Led live coding sessions and technical discussions to help students solve programming challenges",
      "Wrote tests with Jest and Mocha",
    ],
    skills: ["TypeScript", "Express", "Jest", "Mocha"],
  },
];
